<input
    name="numericValue"
    type="number"
    [value]="$displayString()"
    [attr.step]="$type() === 'int' ? 1 : 'any'"
    (change)="setDisplayString($any($event.target).value)"
    (focus)="onFocus()"
    (blur)="onBlur()"
    placeholder="{{ $placeholder() }}"
    class="cm-input"
    [readonly]="$readonly()"
    [class.cm-button]="$isButton()"
    [disabled]="$disabled()"
/>
